module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creator-search-page"
  }, [_c('section', {
    staticClass: "creator-search-panel"
  }, [_c('div', {
    staticClass: "creator-search-primary"
  }, [_c('v-text-field', {
    staticClass: "creator-search-input",
    attrs: {
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "hide-details": "",
      "label": "Search creators",
      "placeholder": "Name, handle, email, keyword or category",
      "dense": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "creator-search-submit",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.paginate()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("Search\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "creator-filters-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.filtersExpanded = !_vm.filtersExpanded
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-tune-variant")]), _vm._v("\n        Filters\n        "), (_vm.activeFilterCount) ? _c('span', {
    staticClass: "creator-filter-count"
  }, [_vm._v(_vm._s(_vm.activeFilterCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "creator-actions-toggle",
          attrs: {
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-dots-horizontal")]), _vm._v("Actions\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "creator-actions-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Reset filters")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.downloadSampleUpload
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Download template")])], 1), _vm._v(" "), (_vm.isAdminRole) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$refs.igBulkHandle.click()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-home-import-outline")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Import creators")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminRole) ? _c('v-list-item', {
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-file-excel-outline")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Export results")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersExpanded),
      expression: "filtersExpanded"
    }],
    staticClass: "creator-filters-accordion"
  }, [_c('div', {
    staticClass: "creator-quick-filters"
  }, [_c('span', {
    staticClass: "creator-quick-filters__label"
  }, [_vm._v("Quick filters")]), _vm._v(" "), _c('div', {
    staticClass: "creator-quick-filters__options"
  }, [_c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "IMS Onboarded",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.imsOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "imsOnly", $$v)
      },
      expression: "filters.imsOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Rate Card Submitted",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.rateCardOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCardOnly", $$v)
      },
      expression: "filters.rateCardOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Past Campaigns",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.pairedCreatorOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pairedCreatorOnly", $$v)
      },
      expression: "filters.pairedCreatorOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Travel Form",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.travelFormOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelFormOnly", $$v)
      },
      expression: "filters.travelFormOnly"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "creator-advanced-filters"
  }, [_c('div', {
    staticClass: "creator-advanced-filters__header"
  }, [_c('div', [_c('span', [_vm._v("Advanced filters")]), _vm._v(" "), _c('small', [_vm._v("Audience, campaign, travel and pricing details")])]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "#8b92a5"
    }
  }, [_vm._v("mdi-tune-variant")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "row align-left",
    staticStyle: {
      "text-align": "left",
      "justify-content": "left",
      "margin": "5px 10% 0px"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n          ")])]
      }
    }]),
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.allTags,
      "item-text": "name",
      "item-value": "id",
      "hide-selected": "",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "chips": "",
      "label": "Tag",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n              $delete\n            ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.filters.tags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tags", $$v)
      },
      expression: "filters.tags"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Gender",
      "items": _vm.genderOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.gender),
      callback: function($$v) {
        _vm.$set(_vm.filters, "gender", $$v)
      },
      expression: "filters.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Platform",
      "items": _vm.platformOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-platform-option"
        }, [(item.icon) ? _c('v-icon', {
          staticClass: "creator-platform-option__icon",
          attrs: {
            "color": item.iconColor,
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          staticClass: "creator-platform-option__image",
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-platform-option creator-platform-option--selected"
        }, [(item.icon) ? _c('v-icon', {
          staticClass: "creator-platform-option__icon",
          attrs: {
            "color": item.iconColor,
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          staticClass: "creator-platform-option__image",
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.platform),
      callback: function($$v) {
        _vm.$set(_vm.filters, "platform", $$v)
      },
      expression: "filters.platform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Tier",
      "items": _vm.infTiers,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.tier),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tier", $$v)
      },
      expression: "filters.tier"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignVerticals,
      "item-value": "id",
      "item-text": "name",
      "label": "Campaign Verticals",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.vertical),
      callback: function($$v) {
        _vm.$set(_vm.filters, "vertical", $$v)
      },
      expression: "filters.vertical"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignTypeDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Type",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "campaignType", $$v)
      },
      expression: "filters.campaignType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.ageGroupDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Age Group",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ageGroup", $$v)
      },
      expression: "filters.ageGroup"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Date of Birth",
            "placeholder": "Date of Birth",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.filters.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.filters, "dateOfBirth", $$v)
            },
            expression: "filters.dateOfBirth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dateOfBirthCal),
      callback: function($$v) {
        _vm.dateOfBirthCal = $$v
      },
      expression: "dateOfBirthCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateOfBirth", $$v)
      },
      expression: "filters.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelDOB()
      }
    }
  }, [_vm._v("\n              Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.okDOB()
      }
    }
  }, [_vm._v("\n              OK\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', _vm._g(_vm._b({
    attrs: {
      "type": "number",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "placeholder": "Age"
    },
    model: {
      value: (_vm.filters.age),
      callback: function($$v) {
        _vm.$set(_vm.filters, "age", $$v)
      },
      expression: "filters.age"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-text-field', _vm._g(_vm._b({
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "placeholder": "Travel Destinations"
    },
    model: {
      value: (_vm.filters.travelCountry),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelCountry", $$v)
      },
      expression: "filters.travelCountry"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Travel Period",
            "placeholder": "Travel Period",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.filters.travelDate),
            callback: function($$v) {
              _vm.$set(_vm.filters, "travelDate", $$v)
            },
            expression: "filters.travelDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.travelDateCal),
      callback: function($$v) {
        _vm.travelDateCal = $$v
      },
      expression: "travelDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.travelDate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelDate", $$v)
      },
      expression: "filters.travelDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelTravelDate()
      }
    }
  }, [_vm._v("\n              Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.okTravelDate()
      }
    }
  }, [_vm._v("\n              OK\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "310px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "outlined": "",
      "clearable": "",
      "items": _vm.allCampaigns,
      "label": "Campaign",
      "item-value": "name",
      "hide-details": "",
      "item-text": "fullName"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.fullName) + "\n          ")])]
      }
    }]),
    model: {
      value: (_vm.filters.campaign),
      callback: function($$v) {
        _vm.$set(_vm.filters, "campaign", $$v)
      },
      expression: "filters.campaign"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false,
      "min-width": "300px",
      "max-width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "creator-rate-filter",
          attrs: {
            "value": _vm.rateFilterLabel,
            "label": "Rate",
            "append-icon": "mdi-menu-down",
            "outlined": "",
            "dense": "",
            "readonly": "",
            "clearable": "",
            "hide-details": "auto"
          },
          on: {
            "click:clear": function($event) {
              $event.stopPropagation();
              return _vm.clearRateFilter.apply(null, arguments)
            }
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.rateFilterMenu),
      callback: function($$v) {
        _vm.rateFilterMenu = $$v
      },
      expression: "rateFilterMenu"
    }
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                Content Type\n                "), _c('v-select', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "item-value": "value"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-content-type-option",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-content-type-option creator-content-type-option--selected",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                Currency\n                "), _c('v-combobox', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                From\n                "), _c('v-text-field', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                To\n                "), _c('v-text-field', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "creator-rate-filter-actions"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearRateFilter()
      }
    }
  }, [_vm._v("\n              Clear all\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.applyRateFilter()
      }
    }
  }, [_vm._v("\n              Apply\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('section', {
    staticClass: "creator-results-panel"
  }, [_c('div', {
    staticClass: "creator-results-toolbar"
  }, [_c('div', [(_vm.selectedLists.length === 0) ? _c('span', {
    staticClass: "creator-results-count"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalItems || 0))]), _vm._v(" creators\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLists.length > 0 && _vm.isSuperAdmin),
      expression: "selectedLists.length > 0 && isSuperAdmin"
    }],
    attrs: {
      "small": "",
      "color": "red",
      "disabled": !_vm.selectedLists || _vm.selectedLists.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteMultipleInf()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-delete-forever")]), _vm._v(" Delete (" + _vm._s(_vm.selectedLists.length) + ")")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right creator-results-toolbar__actions"
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  Sort By\n                  "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  Type\n                  "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg"
        })])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Column settings")])])], 1)]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "search-creator-table",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "items-per-page": 20,
      "show-select": "",
      "item-key": "_id"
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([{
      key: ("item." + (_vm.customSlots.instagram)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['instagram']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": true,
            "isTikTok": false,
            "isYoutube": false,
            "instagramHandle": item['instagram'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.igCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.igCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.tiktok)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['tiktok']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": true,
            "isYoutube": false,
            "tiktokHandle": item['tiktok'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.tiktokCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.tiktokCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.youtube)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['youtube']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": false,
            "isYoutube": true,
            "youtubeHandle": item['youtube'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.youtubeCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.youtubeCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.linkedin)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(_vm.getLinkedInHandle(item)) ? _c('div', [_c('social-handle', {
          attrs: {
            "isLinkedIn": true,
            "linkedinHandle": _vm.getLinkedInHandle(item),
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.twitter)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(_vm.getTwitterHandle(item)) ? _c('div', [_c('social-handle', {
          attrs: {
            "isTwitter": true,
            "twitterHandle": _vm.getTwitterHandle(item),
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: "item.xiaohongshu",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['xiaohongshu']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": false,
            "isYoutube": false,
            "isXiaohongshu": true,
            "xiaohongshuHandle": item['xiaohongshu'],
            "xiaohongshuFullName": item['xhsFullName'],
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.type)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(_vm.getTypeText(item.type)) + "\n          ")])])]
      }
    }, {
      key: "item.pastCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.campaignsCount) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openCampaignListsModal(item, false)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_vm._v("Campaigns  "), _c('strong', [_vm._v("(" + _vm._s(item.campaignsCount) + ")")])])]) : _vm._e(), _vm._v(" "), (!item.campaignsCount && item.pastCampaigns) ? _c('div', _vm._l((item.pastCampaigns), function(preferred, index) {
          return _c('div', {
            key: index
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(preferred))])], 1)
        }), 0) : _vm._e()], 1)])]
      }
    }, {
      key: "item.instagramFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['instagramFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['instagramFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['tiktokFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['tiktokFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.youtubeFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['youtubeFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['youtubeFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.linkedinFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "170px"
          }
        }, [(_vm.getLinkedInFollowers(item) !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getLinkedInFollowers(item))))]) : _c('span', [_vm._v("-")])])])]
      }
    }, {
      key: "item.twitterFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "170px"
          }
        }, [(_vm.getTwitterFollowers(item) !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getTwitterFollowers(item))))]) : _c('span', [_vm._v("-")])])])]
      }
    }, {
      key: "item.xhsFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['xhsFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['xhsFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.emailEdit) ? _c('div', [_c('v-text-field', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: (item.email),
            callback: function($$v) {
              _vm.$set(item, "email", $$v)
            },
            expression: "item.email"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateImportedCreator(item, 'email')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeImportedCreatorEdit('emailEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.emailEdit) ? _c('div', [(item.email) ? _c('v-chip', {
          staticStyle: {
            "min-width": "20px"
          },
          attrs: {
            "small": "",
            "color": "default"
          }
        }, [_vm._v("\n              " + _vm._s(item.email) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeImportedCreatorEdit('emailEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Email")])])], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n          " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'DD MMM, YYYY') : '') + "\n        ")])]
      }
    }, {
      key: "item.ageGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n          " + _vm._s(item.ageGroup || '') + "\n        ")])]
      }
    }, {
      key: "item.shortDescription",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_c('p', {
          staticClass: "remark-text",
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_vm._v(_vm._s(item.shortDescription || '-'))]), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.shortDescription),
            expression: "item.shortDescription"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.shortDescription && item.shortDescription.length > 1),
                  expression: "item.shortDescription && item.shortDescription.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Short Description")]), _vm._v(" "), _c('v-divider'), _vm._v("                                    \n                  " + _vm._s(item.shortDescription) + "\n                ")], 1)], 1)], 1)], 1)])]
      }
    }, {
      key: "item.ccRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.ccRemarksCount) ? _c('div', [(item.ccRemarksCount) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openCampaignListsModal(item, true)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_c('strong', [_vm._v("Remarks (" + _vm._s(item.ccRemarksCount) + ")")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.campaignsCount && item.pastCampaigns) ? _c('div') : _vm._e()])])]
      }
    }, {
      key: "item.statsAnalysis",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.pairingHistory && item.pairingHistory.length) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewStatsAnalysis(item)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_c('strong', [_vm._v("View Stats")])])]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.travelForm",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.travelForm) ? _c('v-btn', {
          attrs: {
            "color": "info",
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.getTravelDataToView(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-wallet-travel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Travel Form")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.rateCard",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.rateCardID && item.rateCard) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "info",
            "outlined": ""
          },
          on: {
            "click": function($event) {
              return _vm.getRateCardDataToView(item.rateCard)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('img', _vm._g({
                attrs: {
                  "src": "/static/img/material_icons/mdi--money.svg",
                  "width": "25px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Rate Card")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.PairedCreators",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.pairedCreator) ? _c('v-btn', {
          attrs: {
            "text": "",
            "small": "",
            "color": "warning",
            "href": ("/paired/creators?handle=" + (item.pairedCreator.handle)),
            "target": '_blank'
          }
        }, [_vm._v("\n              View\n            ")]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.tags",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', _vm._l((item.tags), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "warning",
              "text-color": "white",
              "small": ""
            }
          }, [_vm._v("\n              " + _vm._s(item) + "\n            ")])], 1)
        }), 0)]
      }
    }, {
      key: "item.genre",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticStyle: {
            "min-width": "150px"
          }
        }, [(!item.genre || item.genre.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.genre), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.genre),
            expression: "item.genre"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.genre && item.genre.length > 1),
                  expression: "item.genre && item.genre.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                More...\n              ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.genre), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.IMS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.influencerID) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.getInfluencerDataToView(item.influencerID, item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Influencer")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.Audience",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.audienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View IG Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.tiktokAudienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tiktok-32.png",
                  "width": "17px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View TikTok Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.youtubeAudienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Youtube Aud")])])], 1)], 1)])]
      }
    }, {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n          " + _vm._s(_vm.utils.formatCustomDate(item.createdAt, 'DD-MM-YYYY')) + "\n        ")])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticStyle: {
            "min-width": "280px"
          }
        }, [_c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.showAddTagDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-tag")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Add Tag")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.instagram
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch IG Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.tiktok
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tik-tok-white.png",
                  "width": "12px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch TikTok Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.youtube
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch Youtube Aud")])])], 1), _vm._v(" "), (_vm.isSuperAdmin) ? _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "red",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteInf(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "white",
                  "small": ""
                }
              }, on), [_vm._v("mdi-delete-forever")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1) : _vm._e()], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Creators Search",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('campaign-lists-modal', {
    attrs: {
      "items": _vm.viewCampaigns,
      "handle": _vm.viewHandle,
      "isRemark": _vm.isCcRemarks,
      "emptyCampaigns": _vm.emptyCampaigns,
      "value": _vm.viewCampaignListsDialog
    },
    model: {
      value: (_vm.viewCampaignListsDialog),
      callback: function($$v) {
        _vm.viewCampaignListsDialog = $$v
      },
      expression: "viewCampaignListsDialog"
    }
  }), _vm._v(" "), _c('add-tag-modal', {
    attrs: {
      "item": _vm.editTagItem
    },
    on: {
      "saved": _vm.saveTagProcess
    },
    model: {
      value: (_vm.addTagDialog),
      callback: function($$v) {
        _vm.addTagDialog = $$v
      },
      expression: "addTagDialog"
    }
  }), _vm._v(" "), (_vm.rateCardViewData) ? _c('ratecard-view-modal-dialog', {
    attrs: {
      "value": _vm.rateCardViewDialog,
      "data": _vm.rateCardViewData
    },
    on: {
      "updated": _vm.paginate
    },
    model: {
      value: (_vm.rateCardViewDialog),
      callback: function($$v) {
        _vm.rateCardViewDialog = $$v
      },
      expression: "rateCardViewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }), _vm._v(" "), _c('view-travel-modal', {
    attrs: {
      "travelData": _vm.viewTravelData
    },
    model: {
      value: (_vm.viewTravelDialog),
      callback: function($$v) {
        _vm.viewTravelDialog = $$v
      },
      expression: "viewTravelDialog"
    }
  }), _vm._v(" "), _c('view-stats-modal', {
    attrs: {
      "handle": _vm.viewHandle
    },
    model: {
      value: (_vm.viewStatsDialog),
      callback: function($$v) {
        _vm.viewStatsDialog = $$v
      },
      expression: "viewStatsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef0c73fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/SearchCreators/DataTable.vue
// module id = 2314
// module chunks = 0